"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentIdIsRequiredError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when creating a tag without a parent ID
 */
class ParentIdIsRequiredError extends client_library_1.ExtendableError {
    constructor() {
        super(`Tag must have a parent`);
    }
}
exports.ParentIdIsRequiredError = ParentIdIsRequiredError;
//# sourceMappingURL=ParentIdIsRequiredError.js.map